module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickoutside),
      expression: "clickoutside"
    }],
    staticClass: "mu-menu",
    style: ({
      'width': _vm.contentWidth
    }),
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.handleKeydown
    }
  }, [_c('div', {
    ref: "list",
    staticClass: "mu-menu-list",
    class: _vm.menuListClass,
    style: ({
      'width': _vm.contentWidth,
      'max-height': _vm.maxHeight + 'px'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d97772e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/menu/menu.vue
// module id = 423
// module chunks = 1